import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@gemini/core';
import { Accordion } from '@gemini/ui';
export const FaqItem = ({ item }) => {
    return (_jsx(Box, { maxWidth: "100%", children: _jsx(Accordion, { variant: "divided", content: item.answer, marginVertical: "spacing.none", 
            // To pass custom title as a React node
            // @ts-ignore
            title: _jsx(Box, { as: "h3", typography: "typography.body.16.bold", margin: "0", children: item.question }) }) }));
};
